// API base uses the project-wide REACT_APP_BACKEND_URL (kubernetes ingress /api routing).
const API_BASE = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || '';

export async function submitReview(data) {
  const res = await fetch(`${API_BASE}/api/real-talk/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: 'Submission failed' }));
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Submission failed');
  }
  return res.json();
}

export async function uploadVoiceReview(reviewId, audioBlob) {
  const formData = new FormData();
  formData.append('file', audioBlob, `${reviewId}.webm`);
  const res = await fetch(`${API_BASE}/api/real-talk/upload-voice/${reviewId}`, {
    method: 'POST',
    body: formData,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: 'Upload failed' }));
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Voice upload failed');
  }
  return res.json();
}

export async function fetchReviews({ college, course, minRating, reviewType, verifiedOnly, page = 1, limit = 12 } = {}) {
  const params = new URLSearchParams();
  if (college) params.set('college', college);
  if (course) params.set('course', course);
  if (minRating) params.set('min_rating', minRating);
  if (reviewType && reviewType !== 'all') params.set('review_type', reviewType);
  if (verifiedOnly) params.set('verified_only', 'true');
  params.set('page', page);
  params.set('limit', limit);
  const res = await fetch(`${API_BASE}/api/real-talk/reviews?${params.toString()}`);
  if (!res.ok) throw new Error('Failed to fetch reviews');
  return res.json();
}

export async function fetchStats() {
  const res = await fetch(`${API_BASE}/api/real-talk/stats`);
  if (!res.ok) throw new Error('Failed to fetch stats');
  return res.json();
}

export async function fetchCollegeAutocomplete(query) {
  if (!query || query.length < 2) return [];
  const res = await fetch(`${API_BASE}/api/real-talk/colleges-autocomplete?q=${encodeURIComponent(query)}`);
  if (!res.ok) return [];
  const data = await res.json();
  return data.colleges || [];
}

export async function fetchCourseOptions() {
  const res = await fetch(`${API_BASE}/api/real-talk/course-options`);
  if (!res.ok) throw new Error('Failed to fetch options');
  return res.json();
}

export async function flagReview(reviewId) {
  const res = await fetch(`${API_BASE}/api/real-talk/flag/${reviewId}`, { method: 'POST' });
  if (!res.ok) throw new Error('Failed to flag review');
  return res.json();
}

// Voice review URL — resolves the backend-relative /api/real-talk/voice/... to an absolute URL.
export function absoluteVoiceUrl(url) {
  if (!url) return null;
  if (/^https?:/i.test(url)) return url;
  return `${API_BASE}${url}`;
}
